import React from 'react'
import { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

interface CardFooterProps {
  children: ReactNode
  className?: string
}

const CardFooter: React.FC<CardFooterProps> = ({ children, className }) => (
  <footer className={twMerge('flex flex-col gap-y-2', className)}>
    {children}
  </footer>
)

export default CardFooter
